import { styled } from 'styled-components';

export const StyledScreen = styled.div<{ bg: string }>`
    display: flex;
    justify-content: center;
    background-color: ${(props) => props.bg};
    height: 100%;
    width: 100%;
    max-width: 100vw;
    padding: ${(props) => props.theme.spacing(3)};
    box-sizing: border-box;

    @media (max-width: 600px) {
        padding: ${(props) => props.theme.spacing(2)};
    }
`;
